var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "header"
  }, [_c('h4', [_vm._v("Organizations")]), _c('div', {
    staticClass: "buttons"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "icon": "el-icon-plus",
      "round": "",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.create
    }
  }, [_vm._v("New")])], 1)]), _c('Table', {
    attrs: {
      "items": _vm.organizations,
      "columns": _vm.table.columns,
      "actions": _vm.table.actions,
      "loading": _vm.loading
    }
  }), _vm.showEditDialog ? _c('EditDialog', {
    attrs: {
      "item": _vm.item,
      "isOpen": true,
      "onCancel": _vm.cancel,
      "onSave": _vm.save
    }
  }) : _vm._e(), _vm.showOrgMembers ? _c('OrgMembers', {
    attrs: {
      "org": _vm.item,
      "isOpen": true,
      "onCancel": function () {
        return _vm.showOrgMembers = false;
      }
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }